export class ConfigDB {
	static data = {
		settings: {
			layout_type: 'ltr',
			sidebar: {
				type: 'compact-wrapper',
				body_type: 'sidebar-icon'
			},
			sidebar_setting: 'default-sidebar',
		},
		color: {
			primary_color: '#F0610F',
			secondary_color: '#680ebb',
			mix_background_layout: 'light-only',
		},
		router_animation: 'fadeIn'
	}
}
export default ConfigDB;




